import { render, staticRenderFns } from "./CollectionTelMarket.vue?vue&type=template&id=8a3be12c&scoped=true"
import script from "./CollectionTelMarket.vue?vue&type=script&lang=js"
export * from "./CollectionTelMarket.vue?vue&type=script&lang=js"
import style0 from "./CollectionTelMarket.vue?vue&type=style&index=0&id=8a3be12c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a3be12c",
  null
  
)

export default component.exports